import React from "react";
import { sample } from "lodash";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

function formatLatexPreview(input) {
  return input
    .replaceAll("*", "\\cdot ")
    .replaceAll("/", "\\div ")
    .replaceAll("sqrt", "\\sqrt")
    .replaceAll("-", " - ")
    .replaceAll("+", " + ");
}


// Lista dozwolonych kątów z pominięciem tych z dokładnymi wartościami
const ANGLES = Array.from({ length: 86 }, (_, i) => i + 1)
  .filter((a) => ![30, 45, 60].includes(a) && a <= 89);

// Zakres wartości przybliżonych z tabeli (przykładowy – do uzupełnienia)
function getApproxValue(func, angle) {
  const rad = (angle * Math.PI) / 180;
  switch (func) {
    case "sin":
      return Math.sin(rad);
    case "cos":
      return Math.cos(rad);
    case "tg":
      return Math.tan(rad);
    default:
      return null;
  }
}

export function generateTask() {
  let func, angle, value;
  do {
    func = sample(["sin", "cos", "tg"]);
    angle = sample(ANGLES);
    value = getApproxValue(func, angle);
  } while (!isFinite(value) || Math.abs(value) > 20); // unikaj nieskończonych tangensów

  const rounded = Number(value.toFixed(3));

  const task = {
    type: "ApproximateTrigValueTask",
    func,
    angle,
    expectedAnswer: rounded.toString(),
    expectedValue: rounded,
  };

  return {
    ...task,
    data: task,
  };
}

export function renderTask({ func, angle }) {
  return (
    <p>
      Podaj wartość funkcji trygonometrycznej:{" "}
      <InlineMath math={`\\${func}(${angle}^\\circ)`} />
    </p>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
return (
  <FractionInput
    value={userAnswer}
    onChange={onChange}
    disabled={disabled}
    label="x"
  />
);

}

export function renderAnswer({ func, angle, expectedAnswer }) {
  return (
    <div style={{ marginTop: "0.5rem" }}>
      <InlineMath math={`\\${func}(${angle}^\\circ) \\approx ${expectedAnswer}`} />
    </div>
  );
}

export function checkAnswer({ expectedValue }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = userAnswer.parsed;
  if (typeof given !== "number") return false;

  return Math.abs(expectedValue - given) <= 0.02;
}



export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(userAnswer.raw)} />;
}



export function renderExplanation(input) {
  const data = input?.data ?? input;
  const { func, angle, expectedAnswer } = data;

  return (
    <div className="space-y-4">
      <div>
        <strong>Wyjaśnienie:</strong> Korzystając z tabeli funkcji trygonometrycznych (np. na końcu karty wzorów), odczytujemy:
        <div className="my-2">
          <BlockMath
            math={`\\${func}(${angle}^\\circ) \\approx ${expectedAnswer}`}
          />
        </div>
      </div>
    </div>
  );
}
